import { IItemForGetShortInfo, ITotalPrice } from 'types';
import React, { useCallback, useMemo } from 'react';
import ModifierGroupsMultipleSelect from './components/ModifierGroupsMultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './ModifierGroupField.module.scss';

interface IModifierGroupField {
	setModifierGroups: (value: string[]) => void;
	selectedModifierGroups: string[];
	setFetchedModifierGroups: (value: IItemForGetShortInfo[]) => void;
	totalPrices: ITotalPrice[];
	fetchedModifierGroups: IItemForGetShortInfo[];
}

const ModifierGroupField: React.FC<IModifierGroupField> = ({
	selectedModifierGroups,
	totalPrices,
	setFetchedModifierGroups,
	setModifierGroups,
	fetchedModifierGroups,
}) => {
	const handleRemove = useCallback(
		(id: string) => {
			const selectedItems: string[] = selectedModifierGroups.filter((el) => el !== id);
			setModifierGroups(selectedItems);
		},
		[selectedModifierGroups, setModifierGroups],
	);

	const modifierGroupsList = useMemo(() => {
		return selectedModifierGroups.map((el) => {
			const label = fetchedModifierGroups.find((group) => group.id === el)?.name || '';
			return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
		});
	}, [selectedModifierGroups, fetchedModifierGroups]);

	return (
		<div className={style.container} data-test="ModifierGroupField">
			<div className={style.field}>
				<ModifierGroupsMultipleSelect
					totalPrices={totalPrices}
					selectedModifierGroups={selectedModifierGroups}
					setModifierGroups={setModifierGroups}
					setFetchedModifierGroups={setFetchedModifierGroups}
				/>
			</div>
			<div className={style.groupsList}>{modifierGroupsList}</div>
		</div>
	);
};

export default React.memo(ModifierGroupField);
